import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { AchConfirmationDialogComponent } from '../ach-confirmation-dialog/ach-confirmation-dialog.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { AchRemoveAccountComponent } from '../ach-remove-account/ach-remove-account.component';

export interface Account {
  id: string,
  bankAccountType: string,
  bankName: string, 
  name: string
}

@Component({
  standalone: true,
  selector: 'equine-ui-nx-ach-accounts',
  templateUrl: './ach-accounts.component.html',
  styleUrls: ['./ach-accounts.component.scss'],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule
  ]
})
export class AchAccountsComponent {
  readonly dialog = inject(MatDialog);

  @Input() accounts: Account[] = [];
  @Input() loading = false;

  @Output() selected = new EventEmitter<{id: string}>();
  @Output() removed = new EventEmitter<{id: string}>();

  removeAccount(id: string) {
    const dialogRef = this.dialog.open(AchRemoveAccountComponent);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.removed.emit({id});
      }
    });
  }


  selectAccount(id: string) {
    const dialogRef = this.dialog.open(AchConfirmationDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selected.emit({id});
      }
    });
  }
}
